import * as React from 'react';
//Fluent UI
import {
  Callout,
  Text,
  Icon
} from 'office-ui-fabric-react';

//Theme
import style from './style';

const styles = style.contentStyles;


class InfoCallout extends React.Component{


  render(){
    const {buttonId,onClose,pivotItem} = this.props;
    return (
      <Callout
      className={styles.callout}
      ariaLabelledBy='info-label'
      ariaDescribedBy='info-description'
      role="alertdialog"
      gapSpace={0}
      target={`#${buttonId}`}
      onDismiss={onClose}
      setInitialFocus
    >
     <Text block variant="xLarge" className={styles.title} id='info-label'>
        Jelmagyarázat
      </Text>
      {pivotItem==='0' && <React.Fragment>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
      <Icon className={styles.downloadAll} iconName="Installation"/>
      <Text block variant="small" id='info-hasWinner'>
        Összes file letöltése.
      </Text>
      </div>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
        <Icon className={styles.download} iconName="Download"/>  
        <Text block variant="small" id='info-open-folder'>
        File letöltése.
        </Text>
      </div></React.Fragment>}
      {pivotItem==='1' && <React.Fragment>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
      <Icon className={styles.downloadAll} iconName="Installation"/>
      <Text block variant="small" id='info-hasWinner'>
        Összes file letöltése.
      </Text>
      </div>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
        <Icon className={styles.download} iconName="Download"/>  
        <Text block variant="small" id='info-open-folder'>
        File letöltése.
        </Text>
      </div>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
      <Icon className={styles.edit} iconName="Edit"/> 
      <Text block variant="small" id='info-closed'>
        File módosítása.
      </Text>
      </div>
      <div style={{display:'flex',alignItems:'center',padding:'0.2rem'}}>
        <Icon className={styles.delete} iconName="Delete"/>  
        <Text block variant="small" id='info-open-folder'>
          File törlése.
        </Text>
      </div>
      </React.Fragment>}

    </Callout>
  );
  }
};

export default InfoCallout;